import { AuthContext } from 'context/AuthContext';
import { useContext } from 'react';
import { UIElementProps } from 'types/prop-types';
import '../../assets/styles/base.scss';
import Header from './Header/index';

export function AppContainer({ children }: UIElementProps) {
    const { isAuthenticated } = useContext(AuthContext);

    return (
        <div className="flex flex-col w-full min-h-screen">
            <>
                {isAuthenticated && <Header />}
                <div className={isAuthenticated ? 'pt-4 md:pt-16 mb-24' : ''}>
                    <div className={isAuthenticated ? 'wrapper-container' : ''}>{children}</div>
                </div>
            </>
        </div>
    );
}
